import { CreateAuthentication } from "@musicaudienceexchange/firebase-auth-ui";

export const { UserContext, UserProvider, useUser } = CreateAuthentication({
  loadClaims: (claims) => ({
    admin: typeof claims.admin === "boolean" && claims.admin === true,
    sudoer: typeof claims.sudoer === "boolean" && claims.sudoer === true,
  }),
});
